import script from "./ImageInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageInput.vue?vue&type=script&setup=true&lang=ts"

import "./ImageInput.vue?vue&type=style&index=0&id=cd205fbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd205fbe"]])

export default __exports__